import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Reuse the worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@4.4.168/build/pdf.worker.min.mjs`;

export default function PDFThumbnails({ 
  fileUrl, 
  selectedPage, 
  onPageClick, isOpen = true
}) {
  const [numPages, setNumPages] = React.useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div className={`thumbnails-sidebar ${!isOpen ? 'closed' : ''}`}>
      <Document
        file={fileUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div style={{padding: 10, color: '#aaa'}}>Loading...</div>}
      >
        {Array.from(new Array(numPages), (el, index) => {
            const pageNum = index + 1;
            return (
                <div 
                    key={`thumb_${pageNum}`}
                    className={`thumbnail-wrapper ${selectedPage === pageNum ? 'thumb-selected' : ''}`}
                    onClick={() => onPageClick(pageNum)}
                >
                    <Page 
                        pageNumber={pageNum} 
                        width={120} // Fixed width for thumbnails
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        loading={null}
                    />
                    <div className="thumb-label">{pageNum}</div>
                </div>
            );
        })}
      </Document>
    </div>
  );
}